export const injectStyles = (styles: string) => {
  const cards = document.querySelector('guruwalk-tour-cards');
  if (!cards?.shadowRoot) return;

  const existingStyle = cards.shadowRoot.querySelector('#guruwalk-styles');
  if (existingStyle) return;

  const style = document.createElement('style');
  style.id = 'guruwalk-styles';
  style.textContent = styles;
  cards.shadowRoot.appendChild(style);
};

export const removeStyles = () => {
  const cards = document.querySelector('guruwalk-tour-cards');
  if (!cards?.shadowRoot) return;

  const existingStyle = cards.shadowRoot.querySelector('#guruwalk-styles');
  if (existingStyle) {
    existingStyle.remove();
  }
};
